import { render } from "./ContactPopup.vue?vue&type=template&id=a8b5e77e"
import script from "./ContactPopup.vue?vue&type=script&lang=js"
export * from "./ContactPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__